import * as z from "zod";
import { automationSummarySchema } from "./common";

export const listAutomations = {
  name: "listAutomations" as const,
  input: z.object({ triggerKind: z.string().optional() }),
  output: z.object({ automations: z.array(automationSummarySchema) }),
};
